import {useQuery} from '@tanstack/react-query';

import {trustAccountKeys} from '@/features/trust-accounts/hooks';
import {useApiClient} from '@/hooks';

import {trustAccountGuestsApi} from '../api';

export function useTrustAccountGuestsQuery(
  trustAccountId: string,
  {enabled = true}: {enabled?: boolean} = {}
) {
  const client = useApiClient();

  return useQuery({
    queryKey: trustAccountKeys.guests(trustAccountId),
    queryFn: () => trustAccountGuestsApi.fetchGuests(client, trustAccountId),
    select: response => response.data,
    enabled
  });
}

export function useTrustAccountGuestEventsQuery(
  trustAccountId: string,
  {enabled}: {enabled: boolean}
) {
  const client = useApiClient();

  return useQuery({
    queryKey: trustAccountKeys.guestEvents(trustAccountId),
    queryFn: () => trustAccountGuestsApi.fetchGuestEvents(client, trustAccountId),
    select: response => response.data,
    enabled
  });
}
